import React from "react";
import { connect } from "react-redux";
import { isEqual } from "lodash";
import { DownloadFileAction } from "../../../../actions";
import { Container, Box, DateBox } from "./style";
import Button from "../../../../components/button";
import DatePicker from "../../../../components/datepicker";
import { BoxLoading } from "../../../../components/loading";
import { EXPIRED_PREMIUM, FREE } from "../../../../constants/premiumState";
import FeatureDeniedModal from "../../../../containers/app/components/accessDeniedOrReminderModals/featureDeniedModal";

class Index extends React.Component {
  state = {
    selected: "",
    dateStatus: false,
    date: "",
    date_error: "",
    featureLimitModalShow: false,
    featureLimitModalMessage:""
  };
  componentDidUpdate() {
    if (!this.props.data.modalStatus && this.state.dateStatus) {
      this.setState({
        selected: "",
        dateStatus: false,
        date: ""
      });
    }
  }
  icon(type) {
    switch (type) {
      case "pdf":
        return "mapsa-pdf-file-format";
      case "normal_excel":
        return "mapsa-xlsx-file-format";
      case "excel":
        return "mapsa-calculator";
      default:
        return "mapsa-account-report";
    }
  }

  limitFlags(type, fileType, createMessage) {
    const init = this.props.init;
    let pdf_count_remain;
    let pdf_count_limit;
    let premium_state;
    if (init.data) {
      if (init.data.premium) {
        pdf_count_remain = init.data.premium.pdf_count_remain;
        pdf_count_limit = init.data.premium.pdf_count_limit;
      }
      if (init.data.data) {
        if (init.data.data.project) {
          premium_state = init.data.data.project.premium_state;
        }
      }
    }
    if (type === "file-limit") {
      if (fileType !== "pdf"){
        if (createMessage)
          this.setState({featureLimitModalMessage:"شما یک ویژگی حرفه‌ای را پیدا کرده‌اید! امکان دریافت خروجی فایل و بسیاری امکانات دیگر در اشتراک حرفه‌ای مپسا در دسترس می‌باشد."});
        return true;
      }else if(pdf_count_remain <=0){
        if (createMessage)
          this.setState({featureLimitModalMessage:`در نسخه استاندارد تنها مجاز به دریافت ${pdf_count_limit} فایل PDF در روز می‌باشید. برای دسترسی نامحدود به دریافت فایل و بسیاری امکانات دیگر، اشتراک خود را ارتقاء دهید.`});
        return pdf_count_remain <=0;
      }
    } else if (type === "state") {
      return (premium_state === FREE || premium_state === EXPIRED_PREMIUM);
    }
  }

  eventMaker(item) {
    if (!(this.limitFlags("state") && this.limitFlags("file-limit", item.type, true))) {
      if (!item.with_date) {
        this.setState({
          selected: "",
          dateStatus: false,
          date: ""
        });
        this.props.askFile({
          ...item,
          filters: { ...item.filters, file_type: item.type }
        });
      } else {
        this.setState({
          selected: item,
          dateStatus: true
        });
      }
    } else {
      this.setState({ featureLimitModalShow: true });
    }
  }
  render() {
    const { data } = this.props;
    const {
      selected,
      date,
      dateStatus,
      date_error,
      featureLimitModalShow,
      featureLimitModalMessage
    } = this.state;
    if (!data.modalStatus) {
      return "";
    } else {
      return (
        <Container onClick={this.props.closeModal}>
          <FeatureDeniedModal
            status={featureLimitModalShow}
            title="دریافت فایل"
            description={featureLimitModalMessage}
            handleShow={show => this.setState({ featureLimitModalShow: show })}
          />
          <Box
            onClick={e => {
              e.stopPropagation();
            }}
          >
            {data.askLoading ? (
              <BoxLoading />
            ) : (
              <React.Fragment>
                <span>دریافت خروجی</span>
                <ul>
                  {data.modalData.map((item, key) => (
                    <li
                      className={`${isEqual(selected, item) ? "selected" : ""}`}
                      key={key}
                      onClick={() => {
                        this.eventMaker(item);
                      }}
                    >
                      <i className={`icon ${this.icon(item.type)}`} />
                      {item.title}
                      {(this.limitFlags("state") && this.limitFlags("file-limit", item.type)) &&
                        <i className="premium-icon icon mapsa-premium-plan"/>
                      }
                    </li>
                  ))}
                </ul>
                <DateBox status={dateStatus}>
                  <span>تاریخ صدور سند:</span>
                  <DatePicker
                    input={{
                      value: date,
                      onChange: value => {
                        this.setState({
                          date: value,
                          date_error: ""
                        });
                      }
                    }}
                    meta={{
                      error: date_error
                    }}
                  />
                  <div className="text">
                    تاریخ انتخابی شما به عنوان تاریخ صدور سند حسابداری در سند
                    ایجاد شده لحاظ خواهد شد.
                  </div>
                  <Button
                    btn="primary"
                    onClick={() => {
                      if (!date) {
                        this.setState({
                          date_error: "تاریخ الزامی است"
                        });
                      } else {
                        this.props.askFile({
                          ...selected,
                          filters: {
                            ...selected.filters,
                            date,
                            file_type: selected.type
                          }
                        });
                      }
                    }}
                  >
                    دریافت سند
                  </Button>
                </DateBox>
              </React.Fragment>
            )}
          </Box>
        </Container>
      );
    }
  }
}

const mapStateToProps = store => {
  return {
    data: store.DownloadFile,
    init: store.Init
  };
};
const mapDispatchToProps = dispatch => {
  return {
    closeModal: () => {
      dispatch(DownloadFileAction.closeModal());
    },
    askFile: data => {
      dispatch(DownloadFileAction.reportRequest(data));
    }
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Index);
